import { PriceControlAggregatedDTO } from '../dto/PriceControlAggregatedDTO';
import { PriceControlSupplier } from './PriceControlSupplier';

export class PriceControlAggregated {
  suppliersInQueueAmount: number;
  totalItemsInControl: number;
  purchasePriceAverageDiffPercentage: number;
  purchasePriceAverageDiffAbsolute: number;
  salesPriceAverageDiffPercentage: number;
  salesPriceAverageDiffAbsolute: number;
  salesFactorAverageDiffPercentage: number;
  salesFactorMaxDiffPercentage: number;
  suppliers: PriceControlSupplier[];

  constructor({
    suppliersInQueueAmount,
    totalItemsInControl,
    purchasePriceAverageDiffPercentage,
    purchasePriceAverageDiffAbsolute,
    salesPriceAverageDiffPercentage,
    salesPriceAverageDiffAbsolute,
    salesFactorAverageDiffPercentage,
    salesFactorMaxDiffPercentage,
    suppliers,
  }: PriceControlAggregated) {
    this.suppliersInQueueAmount = suppliersInQueueAmount;
    this.totalItemsInControl = totalItemsInControl;

    this.purchasePriceAverageDiffPercentage = purchasePriceAverageDiffPercentage;
    this.purchasePriceAverageDiffAbsolute = purchasePriceAverageDiffAbsolute;
    this.salesPriceAverageDiffPercentage = salesPriceAverageDiffPercentage;
    this.salesPriceAverageDiffAbsolute = salesPriceAverageDiffAbsolute;
    this.salesFactorAverageDiffPercentage = salesFactorAverageDiffPercentage;
    this.salesFactorMaxDiffPercentage = salesFactorMaxDiffPercentage;
    this.suppliers = suppliers;
  }

  static fromDto = (dto: PriceControlAggregatedDTO): PriceControlAggregated =>
    new PriceControlAggregated({
      suppliersInQueueAmount: dto.suppliersInQueueAmount,
      totalItemsInControl: dto.totalItemsInControl,

      purchasePriceAverageDiffPercentage: dto.purchasePriceAverageDiffPercentage,
      purchasePriceAverageDiffAbsolute: dto.purchasePriceAverageDiffAbsolute,
      salesPriceAverageDiffPercentage: dto.salesPriceAverageDiffPercentage,
      salesPriceAverageDiffAbsolute: dto.salesPriceAverageDiffAbsolute,
      salesFactorAverageDiffPercentage: dto.salesFactorAverageDiffPercentage,
      salesFactorMaxDiffPercentage: dto.salesFactorMaxDiffPercentage,
      suppliers: dto.suppliers ? dto.suppliers.map(PriceControlSupplier.fromDto) : [],
    });
}
